import React from "react";
import { ArrowRight } from "lucide-react";
import CommonButton from "../../ui/inputs/CommonButton.js";
import { Box } from "@mui/material";
import { heroArrowAnimation } from "../index.js";
import { Path } from "../../../../static/Constants";

const HeroActions = ({ history }) => {
  return (
    <Box
      className="home-hero-actions"
      sx={{
        display: "flex",
        gap: {
          xs: 1,
          sm: 2,
          md: 3,
        },
        flexWrap: "wrap",
        width: "100%",
        flexDirection: {
          xs: "column",
          sm: "row",
        },
        alignItems: {
          xs: "stretch",
          sm: "center",
        },
      }}
    >
      <CommonButton
        variant="contained"
        size="hero"
        onClick={() => history.push(Path.allLotteries)}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: {
            xs: 1,
            sm: 1.5,
          },
          width: {
            xs: "100%",
            sm: "auto",
          },
          minHeight: {
            xs: "50px",
            sm: "auto",
          },
          fontSize: {
            xs: "15px",
            sm: "inherit",
          },
          ...heroArrowAnimation,
        }}
      >
        Browse all games

        <Box
          component="span"
          className="hero-arrow"
          sx={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "visible",
            width: {
              xs: "18px",
              sm: "18px",
            },
            height: {
              xs: "18px",
              sm: "18px",
            },
            flexShrink: 0,
            color: (theme) =>
              theme.palette.primary.contrastText,
          }}
        >
          <ArrowRight size={18} strokeWidth={2.5} />
        </Box>
      </CommonButton>
    </Box>
  );
};

export default HeroActions;